export default __webpack_public_path__ + "294fc79d06e56d662f3e683ec0e7844b.png";